import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyBpZvYJgY1XNHr8oADvMZHkMr8vTm6vfyw",
  authDomain: "fingerprint-89fc1.firebaseapp.com",
  projectId: "fingerprint-89fc1",
  storageBucket: "fingerprint-89fc1.firebasestorage.app",
  messagingSenderId: "114726402806",
  appId: "1:114726402806:web:1d8ba888597d8894df4ad7",
  measurementId: "G-3QFKFJ8JWZ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);

export default app;
